import { render } from "./EditInvoiceProductLine.vue?vue&type=template&id=b96a8684&scoped=true&ts=true"
import script from "./EditInvoiceProductLine.vue?vue&type=script&lang=ts"
export * from "./EditInvoiceProductLine.vue?vue&type=script&lang=ts"

import "./EditInvoiceProductLine.vue?vue&type=style&index=0&id=b96a8684&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b96a8684"]])

export default __exports__